import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/start-end-date-list';
import AggregateMomentRange from "../../aggregate/aggregate-moment-range";
import AggregateMomentComponent from "../components/aggregate-moment";

export default class StartEndDateField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.START_END_DATE;
    }

    get sortHintMessage() {
        return 'Sort by start-end date';
    }

    getCsvValue(item) {
        if (!item.startDate && !item.endDate) return '';
        return (item.startDate ? Moment(item.startDate).format("YYYY-MM-DD") : '') + ' - ' + (item.endDate ? Moment(item.endDate).format("YYYY-MM-DD") : '');
    }

    getValue(item) {return item.startDate && item.endDate ? Moment.range(item.startDate, item.endDate) : null}

    getAggregateClass() {return AggregateMomentRange}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => Moment(i.item.startDate || '1900-01-01 00:00:00').unix()],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}
}